import { default as calculation6ykQWFgNdvMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailIwjnB8iIIfMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquirygLRWgNlnpeMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93MnxIIwv8xlMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listvtp3JqDMguMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingqmz2FsIhUFMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyouzOcbulVaR0Meta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellaz5myLkHZqMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadost5HJYPfEFJcMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankJjsSg881fjMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniIVWgE5HzmHMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as page7r5JcsYRIdMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testczORaWGu0bMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepage1XJCj7pL83Meta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleo7PMGJuc5JMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsZYqfzJ04VsMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagwQscLU902yMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorzukIP81GiFMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryslqJ791UOVMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionzEu190nmn5Meta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesZgsxsC3NOKMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryr2Z8Q1atQKMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articlei7vh4f5GV4Meta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionjGePEahtyJMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactPOBKHHHUiHMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationJMr3JUGHoNMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationqXEUJbz7yaMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45you3nXlgEkPRbMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailqJNhtwRc4FMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryPu1tcYwiVuMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listx8rh3Y8PVIMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculation6DYqBefXAaMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youYQSC2hgd6rMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryxCNdu8r7TEMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listHFTLaltMRJMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailJVYYY8wYHDMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offer9S0HL89UdKMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryeHCyKZC99UMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youx3JfMoCBQwMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationvy30zidAW9Meta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listT6T84Scx2GMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youcIZt9vZF05Meta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45online3lYEJltsvfMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detail0my4LS53HSMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phone0nd1dIhlqEMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerJEMlONXeDwMeta } from "/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadost5HJYPfEFJcMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankJjsSg881fjMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniIVWgE5HzmHMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: page7r5JcsYRIdMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testczORaWGu0bMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepage1XJCj7pL83Meta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleo7PMGJuc5JMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsZYqfzJ04VsMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagwQscLU902yMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorzukIP81GiFMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryslqJ791UOVMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionzEu190nmn5Meta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesZgsxsC3NOKMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: page7r5JcsYRIdMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryr2Z8Q1atQKMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articlei7vh4f5GV4Meta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionjGePEahtyJMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionjGePEahtyJMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactPOBKHHHUiHMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationJMr3JUGHoNMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationqXEUJbz7yaMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45you3nXlgEkPRbMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailqJNhtwRc4FMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryPu1tcYwiVuMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listx8rh3Y8PVIMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculation6DYqBefXAaMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youYQSC2hgd6rMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryxCNdu8r7TEMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listHFTLaltMRJMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailJVYYY8wYHDMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offer9S0HL89UdKMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryeHCyKZC99UMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youx3JfMoCBQwMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationvy30zidAW9Meta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listT6T84Scx2GMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youcIZt9vZF05Meta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45online3lYEJltsvfMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detail0my4LS53HSMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phone0nd1dIhlqEMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerJEMlONXeDwMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src615990271/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]